// Modül 6 - Mülakat Psikolojisi - İnteraktif İçerikler

const cabinCrewContentsM6Interactive = {
  // ==================== ÜNİTE 1: ELEŞTİRİ KARŞISINDA TUTUM ====================
  'CM-M6-U1-L1': {
    lesson_id: 'CM-M6-U1-L1',
    title: 'Savunmacı Olmamak',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '🛡️ Savunmacılık = Kırmızı Bayrak',
      intro: 'Eleştiri alınca savunmaya geçmek EN BÜYÜK HATA!',
      facts: [
        { icon: '❌', title: 'Savunma', text: '"Ama...", "Hayır aslında...", "Haklı değilsiniz"' },
        { icon: '❌', title: 'Suçlama', text: 'Başkalarını suçlamak' },
        { icon: '✅', title: 'Kabul', text: '"Anlıyorum, haklısınız"' },
        { icon: '✅', title: 'Gelişim', text: '"Bu konuda gelişmek istiyorum"' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: '"Ekip çalışmanız zayıf görünüyor" denilse?',
        options: [
          { text: '"Hayır, çok iyi ekip oyuncusuyum"', isCorrect: false, feedback: '❌ Savunmacı! Dinlemiyor!' },
          { text: '"Teşekkürler, bunu geliştirmek istiyorum"', isCorrect: true, feedback: '✅ Açık fikirli ve gelişim odaklı!' },
          { text: '"Kim söyledi bunu?"', isCorrect: false, feedback: '❌ Saldırgan!' }
        ]
      }
    }
  },

  'CM-M6-U1-L2': {
    lesson_id: 'CM-M6-U1-L2',
    title: 'Gelişim Odaklılık',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '📈 Growth Mindset: Her Eleştiri = Fırsat',
      intro: 'Eleştiriyi nasıl fırsata çevirirsin?',
      steps: [
        { level: 1, title: '👂 DİNLE', desc: 'Söz kesme, not al' },
        { level: 2, title: '🙏 TEŞEKKÜR ET', desc: '"Geri bildirim için teşekkürler"' },
        { level: 3, title: '🧐 ANLA', desc: 'Spesifik noktayı anla' },
        { level: 4, title: '💪 PLAN YAP', desc: 'Nasıl geliştirebilirsin?' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Eleştiri aldığında en iyi ilk tepki?',
        options: [
          { text: 'Açıklama yap', isCorrect: false, feedback: '❌ Önce dinle!' },
          { text: 'Teşekkür et ve dinle', isCorrect: true, feedback: '✅ Olgunluk göstergesi!' },
          { text: 'Sessiz kal', isCorrect: false, feedback: '❌ Tepkisiz kalma!' }
        ]
      }
    }
  },

  'CM-M6-U1-L3': {
    lesson_id: 'CM-M6-U1-L3',
    title: 'Senaryo: Eleştiri',
    type: 'scenario',
    duration: 4,
    xp: 40,
    scenario: {
      question: '🗣️ MÜLAKAT: Eleştiri',
      context: 'Değerlendirmeci: "Cevaplarınız biraz yavaş ve belirsiz geliyor. Karar vermekte zorlanıyor musunuz?"',
      options: [
        { id: 'A', text: '"Hayır, normalde çok hızlıyım"', isCorrect: false },
        { id: 'B', text: '"Haklısınız, düşünce paylaşmadan önce analiz etmeyi severim"', isCorrect: true },
        { id: 'C', text: '"Heyecandan oldu, normalde değilim"', isCorrect: false },
        { id: 'D', text: 'Sessiz kal', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Kabul et ve pozitif çerçevele!',
        wrong: '❌ Savunma veya mazeret kötü izlenim yaratır!'
      },
      explanation: 'Eleştiriyi kabul et + pozitif yönü vurgula + gelişim niyeti göster'
    }
  },

  // ==================== ÜNİTE 2: STRES YÖNETİMİ ====================
  'CM-M6-U2-L1': {
    lesson_id: 'CM-M6-U2-L1',
    title: 'Nefes Teknikleri',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '🌬️ 4-7-8 Nefes Tekniği',
      intro: 'Stresi anında azaltan bilimsel teknik:',
      steps: [
        { level: '4', title: '👃 NEFES AL', desc: '4 saniye boyunca burnundan' },
        { level: '7', title: '⏸️ TUT', desc: '7 saniye nefesini tut' },
        { level: '8', title: '👄 VER', desc: '8 saniye ağızdan yavaşça ver' },
        { level: '🔁', title: 'TEKRARLA', desc: '3-4 kez tekrarla' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Mülakata girmeden 5dk önce?',
        options: [
          { text: 'Son kez notlara bak', isCorrect: false, feedback: '❌ Stresi artırır!' },
          { text: 'Derin nefes al, rahatla', isCorrect: true, feedback: '✅ Sakinlik = Performans!' },
          { text: 'Telefonda taksl', isCorrect: false, feedback: '❌ Dikkat dağıtır!' }
        ]
      }
    }
  },

  'CM-M6-U2-L2': {
    lesson_id: 'CM-M6-U2-L2',
    title: 'Pozitif Düşünce',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '💭 Pozitif Self-Talk',
      intro: 'İç sesin seni nasıl etkiler?',
      categories: [
        { icon: '❌', title: 'NEGATİF', examples: '"Yapamayacağım"', desc: 'Stres ve korku artırır' },
        { icon: '❌', title: 'NEGATİF', examples: '"Herkes benden iyi"', desc: 'Özgüven düşürür' },
        { icon: '✅', title: 'POZİTİF', examples: '"Hazırlandım, yapabilirim"', desc: 'Güven verir' },
        { icon: '✅', title: 'POZİTİF', examples: '"En iyi versiyonumu göstereceğim"', desc: 'Motivasyon sağlar' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Stresli anda iç sesin ne demeli?',
        options: [
          { text: '"Berbat olacak"', isCorrect: false, feedback: '❌ Self-sabotaj!' },
          { text: '"Hazırım, başaracağım"', isCorrect: true, feedback: '✅ Pozitif mindset!' },
          { text: '"Umurumda değil"', isCorrect: false, feedback: '❌ Kayıtsızlık performansı düşürür!' }
        ]
      }
    }
  },

  'CM-M6-U2-L3': {
    lesson_id: 'CM-M6-U2-L3',
    title: '📝 Stres Quiz',
    type: 'quiz',
    duration: 4,
    xp: 45,
    quiz: {
      questions: [
        { q: '4-7-8 tekniğinde "7" ne?', options: ['Nefes al', 'Tut', 'Ver', 'Bekle'], correct: 1 },
        { q: 'Mülakata 5dk kala?', options: ['Not bak', 'Nefes al', 'Telefon', 'Koş'], correct: 1 },
        { q: 'Negatif self-talk?', options: ['Yapılabilir', 'Yapamam', 'Denerim', 'Hazırım'], correct: 1 },
        { q: 'Stres azaltma için?', options: ['Kahve', 'Derin nefes', 'Koşma', 'Bağırma'], correct: 1 },
        { q: 'Power pose süresi?', options: ['10sn', '30sn', '2dk', '10dk'], correct: 2 }
      ]
    }
  },

  // ==================== ÜNİTE 3: ÖZGÜVEN GELİŞTİRME ====================
  'CM-M6-U3-L1': {
    lesson_id: 'CM-M6-U3-L1',
    title: 'Özgüven Nedir?',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '💪 Gerçek Özgüven',
      intro: 'Özgüven = Kendini tanımak + Kabul etmek',
      facts: [
        { icon: '🎯', title: 'Gerçekçilik', text: 'Güçlü ve zayıf yönlerini bil' },
        { icon: '🙂', title: 'Kabul', text: 'Kusurlarınla barışık ol' },
        { icon: '📈', title: 'Gelişim', text: 'Sürekli öğrenme isteği' },
        { icon: '🤝', title: 'Saygı', text: 'Kendine ve başkalarına saygı' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Özgüvenli kişi?',
        options: [
          { text: 'Hata yapmaz', isCorrect: false, feedback: '❌ Herkes hata yapar!' },
          { text: 'Hatayı kabul eder, öğrenir', isCorrect: true, feedback: '✅ Gerçek özgüven!' },
          { text: 'Her şeyi bilir', isCorrect: false, feedback: '❌ Bu kibir!' }
        ]
      }
    }
  },

  'CM-M6-U3-L2': {
    lesson_id: 'CM-M6-U3-L2',
    title: 'Sahte vs Gerçek Özgüven',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🎭 Sahte vs Gerçek',
      intro: 'Farkı bilmek çok önemli!',
      categories: [
        { icon: '❌', title: 'SAHTE', examples: 'Övünme, başkalarını küçümseme', desc: 'Güvensizliği maskeler' },
        { icon: '❌', title: 'SAHTE', examples: 'Eleştiri kabul etmeme', desc: 'Savunmacılık' },
        { icon: '✅', title: 'GERÇEK', examples: 'Alçakgönüllülük, açıklık', desc: 'İç huzur' },
        { icon: '✅', title: 'GERÇEK', examples: 'Başkalarını destekleme', desc: 'Güvenlik hissi' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Sahte özgüven belirtisi?',
        options: [
          { text: 'Başkalarını dinleme', isCorrect: false, feedback: '❌ Bu gerçek özgüven!' },
          { text: 'Sürekli övünme', isCorrect: true, feedback: '✅ Sahte özgüven = Güvensizlik maskesi!' },
          { text: 'Hata kabul etme', isCorrect: false, feedback: '❌ Bu gerçek!' }
        ]
      }
    }
  },

  'CM-M6-U3-L3': {
    lesson_id: 'CM-M6-U3-L3',
    title: 'Özgüven Egzersizleri',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '💪 Power Pose ve Diğer Teknikler',
      intro: 'Özgüveni artıran bilimsel yöntemler:',
      facts: [
        { icon: '🦸', title: 'Power Pose', text: '2dk Superman duruşu = Testosteron artar' },
        { icon: '🙂', title: 'Ayna', text: 'Kendine gülümse, pozitif konuş' },
        { icon: '📝', title: 'Başarı Listesi', text: 'Geçmiş başarılarını yaz' },
        { icon: '🎯', title: 'Görselleştirme', text: 'Başarılı mülakatı hayal et' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Power pose ne kadar yapılmalı?',
        options: [
          { text: '10 saniye', isCorrect: false, feedback: '❌ Çok kısa!' },
          { text: '2 dakika', isCorrect: true, feedback: '✅ Bilimsel olarak kanıtlanmış süre!' },
          { text: '10 dakika', isCorrect: false, feedback: '❌ Gerekmiyor, 2dk yeterli!' }
        ]
      }
    }
  },

  'CM-M6-U3-L4': {
    lesson_id: 'CM-M6-U3-L4',
    title: 'Senaryo: Özgüven Testi',
    type: 'scenario',
    duration: 4,
    xp: 45,
    scenario: {
      question: '💪 MÜLAKAT: Özgüven',
      context: '"Diğer adaylar sizden daha deneyimli görünüyor. Neden sizi tercih edelim?"',
      options: [
        { id: 'A', text: 'Onları bilmiyorum, karşılaştıramam', isCorrect: false },
        { id: 'B', text: 'Ben de iyi özelliklerim var, öğrenme hızım yüksek', isCorrect: true },
        { id: 'C', text: 'Deneyim her şey değil', isCorrect: false },
        { id: 'D', text: 'Haklısınız, şansım yok', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Karşılaştırmadan kendi güçlü yönlerini vurgula!',
        wrong: '❌ Ne kibirli ne de mütevazı ol - dengeli ol!'
      },
      explanation: 'Diğer adayları küçümseme, kendini küçük görme. Kendi benzersiz değerini sun!'
    }
  },

  'CM-M6-U3-L5': {
    lesson_id: 'CM-M6-U3-L5',
    title: '🎮 Özgüven Doğru/Yanlış',
    type: 'truefalse',
    duration: 3,
    xp: 40,
    truefalse: {
      statements: [
        { statement: 'Övünmek özgüven gösterir.', isTrue: false, explanation: '❌ Övünme = Güvensizlik maskesi!' },
        { statement: 'Power pose 2 dakika yapılır.', isTrue: true, explanation: '✅ Bilimsel olarak kanıtlanmış!' },
        { statement: 'Özgüvenli kişi hata yapmaz.', isTrue: false, explanation: '❌ Hata yapar ama kabul eder!' },
        { statement: 'Kendine pozitif konuşmak faydalı.', isTrue: true, explanation: '✅ Pozitif self-talk güçlendirir!' },
        { statement: 'Başkalarını küçümsemek özgüvendir.', isTrue: false, explanation: '❌ Bu güvensizliktir!' }
      ]
    }
  },

  // ==================== ÜNİTE 4: BEDEN DİLİ OKUMA ====================
  'CM-M6-U4-L1': {
    lesson_id: 'CM-M6-U4-L1',
    title: 'Beden Dili Temelleri',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🧍 Beden Dili: %70 İletişim',
      intro: 'Söylediğin değil, gösterdiğin önemli!',
      facts: [
        { icon: '👀', title: 'Göz Teması', text: '%60-70 göz teması ideal' },
        { icon: '🧑‍🤝‍🧑', title: 'Duruş', text: 'Dik ama rahat' },
        { icon: '🙂', title: 'Yüz', text: 'Doğal gülümseme' },
        { icon: '👋', title: 'Eller', text: 'Açık ve görünür' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Göz teması fazla olursa?',
        options: [
          { text: 'Daha iyi izlenim', isCorrect: false, feedback: '❌ %100 göz teması rahatsız edici!' },
          { text: 'Rahatsız edici olabilir', isCorrect: true, feedback: '✅ %60-70 ideal!' },
          { text: 'Önemli değil', isCorrect: false, feedback: '❌ Çok önemli!' }
        ]
      }
    }
  },

  'CM-M6-U4-L2': {
    lesson_id: 'CM-M6-U4-L2',
    title: 'El Hareketleri',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '👋 El Hareketleri ve Anlamları',
      intro: 'Ellerin çok şey söylüyor!',
      categories: [
        { icon: '✅', title: 'Açık Eller', examples: 'Avuclar görünür', desc: 'Dürüstlük, açıklık' },
        { icon: '❌', title: 'Ceplerde', examples: 'Eller saklı', desc: 'Gerginlik, gizlilik' },
        { icon: '❌', title: 'Kol Kavuşturma', examples: 'Göğüste kavustuşuk', desc: 'Kapalılık, savunma' },
        { icon: '✅', title: 'Doğal Jestler', examples: 'Konuşurken hareket', desc: 'Canlılık, ilgi' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Mülakatta eller nerede olmalı?',
        options: [
          { text: 'Cepte', isCorrect: false, feedback: '❌ Gergin görünürsün!' },
          { text: 'Masada görünür, doğal', isCorrect: true, feedback: '✅ Açık ve profesyonel!' },
          { text: 'Kavuşturulmuş', isCorrect: false, feedback: '❌ Kapalı görünürsün!' }
        ]
      }
    }
  },

  'CM-M6-U4-L3': {
    lesson_id: 'CM-M6-U4-L3',
    title: 'Yüz İfadeleri',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🙂 Yüz İfadesi: Gerçek Gülümseme',
      intro: 'Sahte gülümseme fark edilir!',
      facts: [
        { icon: '😊', title: 'Duchenne Gülümseme', text: 'Gözler de gülümser (kırışıklık)' },
        { icon: '😐', title: 'Sahte', text: 'Sadece dudaklar hareket eder' },
        { icon: '👀', title: 'İlgili Yüz', text: 'Kaşlar hafif kalkık' },
        { icon: '🙂', title: 'Doğal', text: 'Zorlamadan gelen ifade' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Gerçek gülümseme nasıl?',
        options: [
          { text: 'Sadece dudaklar hareket', isCorrect: false, feedback: '❌ Bu sahte!' },
          { text: 'Gözler ve dudaklar birlikte', isCorrect: true, feedback: '✅ Duchenne gülümseme!' },
          { text: 'Önemli değil', isCorrect: false, feedback: '❌ Fark edilir!' }
        ]
      }
    }
  },

  'CM-M6-U4-L4': {
    lesson_id: 'CM-M6-U4-L4',
    title: 'Senaryo: Beden Dili',
    type: 'scenario',
    duration: 4,
    xp: 45,
    scenario: {
      question: '🧍 MÜLAKAT: Beden Dili',
      context: 'Mülakatçı kollarını kavuşturmuş ve seni dinliyor. Bu ne anlama geliyor?',
      options: [
        { id: 'A', text: 'Seni beğenmiyor, başarısız olacaksın', isCorrect: false },
        { id: 'B', text: 'Belki soğuk, belki alışkanlık - performansına odaklan', isCorrect: true },
        { id: 'C', text: 'Hemen bitir ve çık', isCorrect: false },
        { id: 'D', text: 'Sen de kollarını kavuştur', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Karşındakini okumaya çalışma, kendi performansına odaklan!',
        wrong: '❌ Beden dilini yorumlama - birden fazla anlamı olabilir!'
      },
      explanation: 'Diğer kişinin beden dilini aşırı analiz etme. Senin görevin en iyi performansı göstermek!'
    }
  },

  'CM-M6-U4-L5': {
    lesson_id: 'CM-M6-U4-L5',
    title: '🎮 Beden Dili Eşleştir',
    type: 'matching',
    duration: 3,
    xp: 40,
    matching: {
      instruction: 'Beden dilini anlamıyla eşleştir',
      pairs: [
        { id: 1, left: 'Açık avuclar', right: 'Dürüstlük' },
        { id: 2, left: 'Kollar kavuşuk', right: 'Kapalılık' },
        { id: 3, left: 'Öne eğilme', right: 'İlgi' },
        { id: 4, left: 'Göz kaçırma', right: 'Güvensizlik' },
        { id: 5, left: 'Duchenne gülümseme', right: 'Gerçek mutluluk' }
      ]
    }
  },

  // ==================== ÜNİTE 5-7: KISALTILMIŞ ====================
  'CM-M6-U5-L1': {
    lesson_id: 'CM-M6-U5-L1',
    title: 'Duygusal Zeka (EQ)',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🧠 EQ: IQ\'dan Daha Önemli',
      intro: 'Duygusal zeka neden kritik?',
      facts: [
        { icon: '👁️', title: 'Farkındalık', text: 'Kendi duygularını tanı' },
        { icon: '🎮', title: 'Yönetim', text: 'Duygularını kontrol et' },
        { icon: '💗', title: 'Empati', text: 'Başkalarını anla' },
        { icon: '🤝', title: 'Sosyal Beceri', text: 'İlişki yönetimi' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'EQ\'nun en önemli bileşeni?',
        options: [
          { text: 'Zeka', isCorrect: false, feedback: '❌ Bu IQ!' },
          { text: 'Empati', isCorrect: true, feedback: '✅ Başkalarını anlamak!' },
          { text: 'Hafıza', isCorrect: false, feedback: '❌ EQ değil!' }
        ]
      }
    }
  },

  'CM-M6-U6-L1': {
    lesson_id: 'CM-M6-U6-L1',
    title: 'Red Cevabı Almak',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '❌ Red = Son Değil, Geri Bildirim',
      intro: 'Red nasıl yönetilir?',
      facts: [
        { icon: '💭', title: 'Kabul Et', text: 'Red normal, herkes yaşar' },
        { icon: '📚', title: 'Öğren', text: 'Neden olduğunu anla' },
        { icon: '💪', title: 'Geliş', text: 'Zayıf noktaları geliştir' },
        { icon: '🔄', title: 'Tekrar Dene', text: 'Pes etme, devam et' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Mülakattan red aldın. Ne yapmalı?',
        options: [
          { text: 'Pes et, bu iş sana göre değil', isCorrect: false, feedback: '❌ Hemen pes etme!' },
          { text: 'Analiz et, geliş, tekrar dene', isCorrect: true, feedback: '✅ Growth mindset!' },
          { text: 'Şirket zaten kötüydü', isCorrect: false, feedback: '❌ Suçlama = Gelişim yok!' }
        ]
      }
    }
  },

  'CM-M6-U7-L1': {
    lesson_id: 'CM-M6-U7-L1',
    title: 'Bir Gün Önce',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '📅 Mülakattan Bir Gün Önce',
      intro: 'Önceki gün checklist:',
      facts: [
        { icon: '👔', title: 'Kıyafet', text: 'Ütülü, hazır, tam takm' },
        { icon: '📄', title: 'Belgeler', text: 'CV, foto, kimlik kontrol' },
        { icon: '🗺️', title: 'Rota', text: 'Adresi ve ulaşımı kontrol et' },
        { icon: '😴', title: 'Uyku', text: 'Erken yat, 7-8 saat uyu' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Mülakattan önceki gece?',
        options: [
          { text: 'Son dakika hazırlık yap', isCorrect: false, feedback: '❌ Stresi artırır!' },
          { text: 'Rahatla, erken uyu', isCorrect: true, feedback: '✅ Dinlenmiş beyin = İyi performans!' },
          { text: 'Parti yap, rahatla', isCorrect: false, feedback: '❌ Yorgun olursun!' }
        ]
      }
    }
  },

  'CM-M6-U7-L4': {
    lesson_id: 'CM-M6-U7-L4',
    title: '🎮 Hazırlık Sıralaması',
    type: 'dragdrop',
    duration: 3,
    xp: 45,
    dragdrop: {
      instruction: 'Mülakat günü hazırlık sırasını SIRALA',
      items: [
        { text: '⏰ Erken uyan, kahvaltı et', order: 1 },
        { text: '🚿 Duş al, hazırlan', order: 2 },
        { text: '👔 Kıyafet giy, son kontrol', order: 3 },
        { text: '📄 Belgeleri kontrol et', order: 4 },
        { text: '🚗 Erkenden yola çık', order: 5 },
        { text: '🧘 Beklerken nefes egzersizi', order: 6 }
      ]
    }
  },

  'CM-M6-U7-L5': {
    lesson_id: 'CM-M6-U7-L5',
    title: '⚡ Hazırlık Yarışı',
    type: 'timerace',
    duration: 3,
    xp: 50,
    timerace: {
      timePerQuestion: 7,
      questions: [
        { q: 'Önceki gece?', options: ['Parti', 'Erken uyu', 'Ders', 'TV'], correct: 1 },
        { q: 'Kaç dk önce orda ol?', options: ['0', '15-30', '60', '90'], correct: 1 },
        { q: 'Power pose süresi?', options: ['10sn', '2dk', '10dk', '30dk'], correct: 1 },
        { q: 'Nefes tekniği?', options: ['2-3-4', '4-7-8', '5-5-5', '10-10'], correct: 1 },
        { q: 'Kıyafet ne zaman hazır?', options: ['Sabah', 'Önceki gece', 'Son dk', 'Mülakatta'], correct: 1 },
        { q: 'Belgeler nerede?', options: ['Çantada hazır', 'Evde', 'Arabada', 'Yok'], correct: 0 }
      ]
    }
  },

  // ==================== EKSİK DERSLER ====================
  // ÜNİTE 5: DUYGUSAL ZEKA - EKSİKLER
  'CM-M6-U5-L2': {
    lesson_id: 'CM-M6-U5-L2',
    title: 'Empati Geliştirme',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '💗 Empati: Başkasının Gözünden Görmek',
      intro: 'Empati = Anlama, sempati = acıma. Fark büyük!',
      facts: [
        { icon: '👂', title: 'Dinle', text: 'Yargılamadan, sadece anla' },
        { icon: '👀', title: 'Gözlemle', text: 'Beden dilini oku' },
        { icon: '🤔', title: 'Düşün', text: '"Ben olsam nasıl hissederdim?"' },
        { icon: '💬', title: 'Yansıt', text: '"Çok zor olmalı" gibi cümleler' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Yolcu uçuşunu kaçırmış ve ağlıyor. Ne dersiniz?',
        options: [
          { text: '"Daha erken gelmeliydiniz"', isCorrect: false, feedback: '❌ Suçlayıcı ve empatisiz!' },
          { text: '"Çok üzgün olmalısınız, size yardımcı olmaya çalışayım"', isCorrect: true, feedback: '✅ Empati + çözüm odaklı!' },
          { text: '"Herkes kaçırıyor bazen"', isCorrect: false, feedback: '❌ Küçümseyici!' }
        ]
      }
    }
  },

  'CM-M6-U5-L3': {
    lesson_id: 'CM-M6-U5-L3',
    title: 'Senaryo: Duygusal Durum',
    type: 'scenario',
    duration: 8,
    xp: 45,
    scenario: {
      question: '😢 SENARYO: Duygusal Yolcu',
      context: 'Bir yolcu sessizce ağlıyor. Yanındaki koltuk boş. Ne yaparsınız?',
      options: [
        { id: 'A', text: 'Nazikçe yaklaşır, bir şeye ihtiyacı olup olmadığını sorarım', isCorrect: true },
        { id: 'B', text: 'Görmezden gelirim, özel alan', isCorrect: false },
        { id: 'C', text: '"Neden ağlıyorsunuz?" diye sorarım', isCorrect: false },
        { id: 'D', text: 'Diğer yolculara söylerim', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Doğru! Nazik ilgi, zorlamadan destek.',
        wrong: '❌ İlgisizlik veya aşırı merak uygun değil. Nazik ve saygılı yaklaşım şart.'
      },
      explanation: '"Size yardımcı olabilir miyim?" veya "Bir şeye ihtiyacınız var mı?" yeterli.'
    }
  },

  'CM-M6-U5-L4': {
    lesson_id: 'CM-M6-U5-L4',
    title: '⚡ EQ Zaman Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 50,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'EQ ne demek?', options: ['IQ', 'Duygusal Zeka', 'Test', 'Sınav'], correct: 1 },
        { q: 'Empati nedir?', options: ['Acıma', 'Anlama', 'Sempati', 'Sevgi'], correct: 1 },
        { q: 'Ağlayan yolcuya?', options: ['Görmezden gel', 'Nazik yaklaş', 'Neden sor', 'Gül'], correct: 1 },
        { q: 'Duygusal zeka geliştirilebilir mi?', options: ['Hayır', 'Evet', 'Bilinmez', 'Doğuştan'], correct: 1 },
        { q: 'Empati vs Sempati farkı?', options: ['Yok', 'Anlama vs Acıma', 'Aynı', 'Zıt'], correct: 1 }
      ]
    }
  },

  // ÜNİTE 6: BAŞARISIZLIK YÖNETİMİ - EKSİKLER
  'CM-M6-U6-L2': {
    lesson_id: 'CM-M6-U6-L2',
    title: 'Growth Mindset',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🌱 Growth Mindset: Gelişim Zihniyeti',
      intro: 'Fixed mindset: "Ben böyleyim". Growth mindset: "Gelişebilirim"',
      categories: [
        { icon: '❌', title: 'Fixed', examples: '"Bunu yapamam"', desc: 'Sabit zihniyet' },
        { icon: '❌', title: 'Fixed', examples: '"Yeteneğim yok"', desc: 'Pes etme' },
        { icon: '✅', title: 'Growth', examples: '"Henüz yapamıyorum"', desc: 'Gelişim' },
        { icon: '✅', title: 'Growth', examples: '"Öğrenebilirim"', desc: 'Azim' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Mülakatta başarısız oldunuz. Ne düşünürsünüz?',
        options: [
          { text: '"Ben bu iş için uygun değilim"', isCorrect: false, feedback: '❌ Fixed mindset!' },
          { text: '"Neyi geliştirebileceğimi öğrendim, tekrar denerim"', isCorrect: true, feedback: '✅ Growth mindset!' },
          { text: '"Onlar hata yaptı, ben iyiyim"', isCorrect: false, feedback: '❌ Suçlama!' }
        ]
      }
    }
  },

  'CM-M6-U6-L3': {
    lesson_id: 'CM-M6-U6-L3',
    title: 'Senaryo: Zor Soru',
    type: 'scenario',
    duration: 8,
    xp: 45,
    scenario: {
      question: '😰 SENARYO: Bilmediğiniz Soru',
      context: 'Jüri teknik bir soru sordu: "Boeing 787\'nin kabin basıncı kaç feet\'e ayarlanır?" Hiçbir fikriniz yok.',
      options: [
        { id: 'A', text: '"Bu konuda bilgim yok, ama öğrenmek isterim. Eğitimde öğreneceğim"', isCorrect: true },
        { id: 'B', text: '"35,000 feet" (uydururum)', isCorrect: false },
        { id: 'C', text: 'Sessiz kalırım', isCorrect: false },
        { id: 'D', text: '"Bu soruyu geçebilir miyiz?"', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Mükemmel! Dürüstlük + öğrenme isteği!',
        wrong: '❌ Uydurmak, kaçınmak veya susmak kötü izlenim bırakır. Dürüst olun.'
      },
      explanation: 'Cevap: ~6000 feet. Ama bilmemek sorun değil, dürüstlük önemli!'
    }
  },

  'CM-M6-U6-L4': {
    lesson_id: 'CM-M6-U6-L4',
    title: 'Ünite Sınavı',
    type: 'quiz',
    duration: 5,
    xp: 50,
    quiz: {
      questions: [
        { q: 'Red cevabı alınca ne yapmalı?', options: ['Pes et', 'Kız', 'Öğren ve tekrar dene', 'Şikayet et'], correct: 2 },
        { q: 'Growth mindset nedir?', options: ['Sabit', 'Gelişebilirim', 'Değişmez', 'Yetenek'], correct: 1 },
        { q: 'Bilmediğin soruya?', options: ['Uydur', 'Dürüst ol', 'Sus', 'Kaçın'], correct: 1 },
        { q: '"Henüz yapamıyorum" hangi mindset?', options: ['Fixed', 'Growth', 'Negatif', 'Nötr'], correct: 1 }
      ]
    }
  },

  // ÜNİTE 7: MÜLAKAT ÖNCESİ HAZIRLIK - EKSİKLER
  'CM-M6-U7-L2': {
    lesson_id: 'CM-M6-U7-L2',
    title: 'Mülakat Sabahı',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🌅 Mülakat Sabahı Rutini',
      intro: 'Stressiz başlangıç için plan şart!',
      steps: [
        { level: 1, title: '⏰ Erken Kalk', desc: 'Alarmı 2 saat önce kur' },
        { level: 2, title: '🚿 Hazırlan', desc: 'Duş, grooming, kıyafet' },
        { level: 3, title: '☕ Kahvaltı', desc: 'Hafif ama besleyici' },
        { level: 4, title: '📄 Belgeler', desc: 'Son kontrol: CV, fotoğraf, kimlik' },
        { level: 5, title: '🚗 Yola Çık', desc: '30-45 dk önce orada ol' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Mülakat sabahı kaç saat önce kalkmalı?',
        options: [
          { text: 'Tam zamanında', isCorrect: false, feedback: '❌ Acele = stres!' },
          { text: '2 saat önce', isCorrect: true, feedback: '✅ Rahat hazırlık için!' },
          { text: '5 saat önce', isCorrect: false, feedback: '❌ Çok erken, yorgun olursun!' }
        ]
      }
    }
  },

  'CM-M6-U7-L3': {
    lesson_id: 'CM-M6-U7-L3',
    title: 'Bekleme Odasında',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🪑 Bekleme Odası Taktikleri',
      intro: 'Değerlendirme bekleme odasında başlar!',
      facts: [
        { icon: '😊', title: 'Gülümse', text: 'Herkese nazik ol' },
        { icon: '🧘', title: 'Sakin Ol', text: 'Nefes egzersizi yap' },
        { icon: '📱', title: 'Telefon', text: 'Sessizde veya kapalı' },
        { icon: '💬', title: 'Sohbet', text: 'Diğer adaylarla nazik ol ama abartma' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Bekleme odasında ne yapmamalı?',
        options: [
          { text: 'Telefonla oynamak', isCorrect: true, feedback: '✅ Telefon kapalı veya sessizde!' },
          { text: 'Gülümsemek', isCorrect: false, feedback: '❌ Gülümseme iyi!' },
          { text: 'Nefes egzersizi', isCorrect: false, feedback: '❌ Rahatlama teknikleri iyi!' }
        ]
      }
    }
  }
};

export default cabinCrewContentsM6Interactive;
